import { render, staticRenderFns } from "./ModalTransferir.vue?vue&type=template&id=a4f91236"
import script from "./ModalTransferir.vue?vue&type=script&lang=js"
export * from "./ModalTransferir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports